export const normalizeCustomerId = (value) => {
  if (value == null) return null
  let stringValue = null
  if (typeof value === "number") stringValue = String(value)
  else if (typeof value === "string") stringValue = value.trim()
  if (!stringValue) return null
  const digitsOnly = stringValue.replace(/[^0-9]/g, "")
  return digitsOnly.length ? digitsOnly : stringValue
}

const ensureArray = (rows) => {
  if (Array.isArray(rows)) return rows
  if (rows == null) return []
  return [rows]
}

export const normalizeGoogleAdsLinkRows = (rows) =>
  ensureArray(rows).map((row) => {
    const cleanedCustomerId =
      typeof row?.customer_id === "string"
        ? row.customer_id.trim()
        : row?.customer_id != null
        ? String(row.customer_id)
        : null

    return {
      ...row,
      customer_id:
        typeof cleanedCustomerId === "string" && cleanedCustomerId.length
          ? cleanedCustomerId
          : cleanedCustomerId,
      normalized_customer_id: normalizeCustomerId(row?.customer_id),
    }
  })

export const normalizeGoogleAdsCostRows = (rows) =>
  ensureArray(rows)
    .map((row) => {
      const rawCost = row?.advertiser_ad_cost
      const numericCost =
        typeof rawCost === "number"
          ? rawCost
          : rawCost != null
          ? Number(rawCost)
          : null

      const cleanedCustomerId =
        typeof row?.google_ads_customer_id === "string"
          ? row.google_ads_customer_id.trim()
          : row?.google_ads_customer_id != null
          ? String(row.google_ads_customer_id)
          : null

      return {
        ...row,
        google_ads_customer_id:
          typeof cleanedCustomerId === "string" && cleanedCustomerId.length
            ? cleanedCustomerId
            : cleanedCustomerId,
        normalized_customer_id: normalizeCustomerId(row?.google_ads_customer_id),
        advertiser_ad_cost:
          numericCost != null && Number.isFinite(numericCost)
            ? numericCost
            : null,
        currency_code:
          typeof row?.currency_code === "string" && row.currency_code.trim()
            ? row.currency_code.trim()
            : null,
      }
    })
    .filter((row) => {
      const trimmedId =
        typeof row?.google_ads_customer_id === "string"
          ? row.google_ads_customer_id.trim().toLowerCase()
          : null
      if (trimmedId === "(not set)") return false
      if (
        typeof row?.normalized_customer_id === "string" &&
        row.normalized_customer_id.toLowerCase() === "(not set)"
      ) {
        return false
      }
      return true
    })

export const computeGoogleAdsIssueCount = (linkRows, costRows) => {
  const normalizedLinks = normalizeGoogleAdsLinkRows(linkRows)
  const normalizedCosts = normalizeGoogleAdsCostRows(costRows)

  const normalizedLinkIds = new Set()
  for (const row of normalizedLinks) {
    const normalizedKey = row?.normalized_customer_id
    if (normalizedKey == null) continue
    const keyString = String(normalizedKey).trim()
    if (!keyString || keyString.toLowerCase() === "(not set)") continue
    normalizedLinkIds.add(keyString)
  }

  let totalIssues = normalizedLinkIds.size === 0 ? 1 : 0

  for (const row of normalizedCosts) {
    const value = row?.advertiser_ad_cost
    if (value == null || !Number.isFinite(value)) continue
    const normalizedKey = row?.normalized_customer_id
    const keyString =
      normalizedKey == null ? null : String(normalizedKey).trim()
    if (!keyString || keyString.toLowerCase() === "(not set)") continue
    const hasLinkedAccount = normalizedLinkIds.has(keyString)
    const isPositiveLowSpend = value > 0 && value < 1
    if (value < 1 && !(hasLinkedAccount && isPositiveLowSpend)) {
      totalIssues += 1
    }
  }

  return totalIssues
}
